import { keepPreviousData } from '@tanstack/react-query';

import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getMessagesAndCalls } from '../api/services/Rides';
import { MessagesAndCallsListItem, MessagesAndCallsQueryParams } from '../types/messagesAndCalls';

interface IUserEventsQuery {
  queryParams: MessagesAndCallsQueryParams;
}

export const useMessagesAndCallsQuery = ({ queryParams }: IUserEventsQuery) => {
  return useApiGet<{ data: MessagesAndCallsListItem[]; meta: Meta }>(
    ['messagesAndCallsList', queryParams.page],
    () => getMessagesAndCalls(queryParams),
    {
      enabled: true,
      mutationKey: 'page',
      placeholderData: keepPreviousData,
    }
  );
};
